import React, { useRef, useEffect, useState } from 'react';
import dashboardImg from '../assets/images/dashboard_purple.png';

const palette = {
  subtitle: '#702fff',
  title: '#18171b',
  desc: '#222',
  bg: '#fff',
};

const DashboardShowcase = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [showTitle, setShowTitle] = useState(false);
  const [showDesc, setShowDesc] = useState(false);
  const [showImg, setShowImg] = useState(false);

  // Intersection Observer for scroll-in animation
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Staggered appearance
  useEffect(() => {
    let titleTimeout, descTimeout, imgTimeout;
    if (visible) {
      titleTimeout = setTimeout(() => setShowTitle(true), 200);
      descTimeout = setTimeout(() => setShowDesc(true), 500);
      imgTimeout = setTimeout(() => setShowImg(true), 800);
    }
    return () => {
      clearTimeout(titleTimeout);
      clearTimeout(descTimeout);
      clearTimeout(imgTimeout);
    };
  }, [visible]);

  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 700;

  return (
    <section ref={sectionRef} style={sectionStyles}>
      <div style={headerWrap}>
        <span style={{
          ...subtitle,
          opacity: showTitle ? 1 : 0,
          transform: showTitle ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.7s cubic-bezier(.4,2,.6,1), transform 0.7s cubic-bezier(.4,2,.6,1)'
        }}>DATA-DRIVEN INSIGHTS</span>
        <h2 style={{
          ...title,
          opacity: showTitle ? 1 : 0,
          transform: showTitle ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.7s cubic-bezier(.4,2,.6,1), transform 0.7s cubic-bezier(.4,2,.6,1)'
        }}>
          Combine Data Sources Seamlessly to Unified Dashboards
        </h2>
        <p style={{
          ...desc,
          opacity: showDesc ? 1 : 0,
          transition: 'opacity 0.7s 0.2s cubic-bezier(.4,2,.6,1)'
        }}>
          Unlock the power of your data with dashboards tailored to your business. With dataqly, any dashboard is possible —turn your data into actionable insights, make data-driven decisions faster, and let Agentic AI do the work.
        </p>
      </div>
      <div style={imgWrap}>
        <img
          src={dashboardImg}
          alt="Dataqly dashboard example"
          style={{
            ...imgStyles,
            maxHeight: isMobile ? 440 : imgStyles.maxHeight, // Much larger for mobile
            minHeight: isMobile ? 220 : undefined, // Ensure substantial height on mobile
            maxWidth: isMobile ? '100vw' : imgStyles.maxWidth || 900, // Use full viewport width on mobile
            width: isMobile ? '100vw' : imgStyles.width,
            height: isMobile ? 'auto' : imgStyles.height,
            objectFit: 'contain',
            opacity: showImg ? 1 : 0,
            transform: showImg ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 0.9s cubic-bezier(.4,2,.6,1), transform 0.9s cubic-bezier(.4,2,.6,1)'
          }}
        />
      </div>
    </section>
  );
};

const sectionStyles = {
  borderRadius: 24,
  margin: '56px auto 0 auto',
  padding: '56px 0 48px 0',
  maxWidth: 1200,
  width: '95%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};
const headerWrap = {
  maxWidth: 900,
  textAlign: 'center',
  margin: '0 auto 40px auto',
};
const subtitle = {
  color: palette.subtitle,
  fontWeight: 700,
  fontSize: 18,
  letterSpacing: 1.5,
  textTransform: 'uppercase',
  marginBottom: 12,
  display: 'inline-block',
  fontFamily: 'Inter, sans-serif',
};
const title = {
  fontSize: 36,
  fontWeight: 400,
  color: palette.title,
  margin: '0 0 18px 0',
  lineHeight: 1.15,
  fontFamily: 'Inter, sans-serif',
};
const desc = {
  color: '#666',
  fontSize: 18,
  fontWeight: 300,
  margin: '0 auto 0 auto',
  maxWidth: 800,
  fontFamily: 'Inter, sans-serif',
  lineHeight: 1.6,
  textAlign: 'center',
};
const imgWrap = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
const imgStyles = {
  width: '100%',
  maxWidth: 900,
  borderRadius: 18,
  marginTop: 24,
  objectFit: 'contain',
};

export default DashboardShowcase;
